import { AxiosInstance } from 'axios';
import { parseOrganizationList } from './utils';
import {
  OrganizationsEnum,
  OrganizationListData,
  PromiseOrganizationListData,
} from './types';

export const getOrganizationListData = (api: AxiosInstance) => ({
  getOrganizationList: async (
    params: any,
    parseData: Function = parseOrganizationList,
  ): Promise<PromiseOrganizationListData> => {
    const { data } = await api.get<OrganizationListData>(
      OrganizationsEnum.GET_ORGANISATION_LIST,
      {
        params,
      },
    );
    return { ...data, data: parseData(data.data) };
  },
});

export const organizationsService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getOrganizationListData(api),
  };
};




// WEBPACK FOOTER //
// ./src/services/api/organizations/organizationsService.ts